import http from './http';

export default {
  all() {
    return http().get(`/v1/analyses`);
  },
  get(id) {
    return http().get(`/v1/analyses/${id}`);
  },
  create(data) {
    return http().post(`/v1/analyses`, data);
  },
  update(data) {
    return http().put(`/v1/analyses/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/analyses/${id}`);
  },
  createFixAndFlipAnalyses(data) {
    return http().post(`/v1/fix_and_flip_analyses`, data);
  },
  updateFixAndFlipAnalyses(data) {
    return http().put(`/v1/fix_and_flip_analyses/${data.id}`, data);
  },
  createWholesaleAnalyses(data) {
    return http().post(`/v1/wholesale_analyses`, data);
  },
  updateWholesaleAnalyses(data) {
    return http().put(`/v1/wholesale_analyses/${data.id}`, data);
  },
  novationAnalysis: {
    get(analysisId) {
      return http().get(`/v1/novation_analysis/${analysisId}`);
    },
    create(data) {
      return http().post(`/v1/novation_analysis`, data);
    },
    update(data) {
      return http().put(`/v1/novation_analysis/${data.id}`, data);
    },
    delete(analysisId) {
      return http().delete(`/v1/novation_analysis/${analysisId}`);
    },
  },
  retailListingAnalysis: {
    get(analysisId) {
      return http().get(`/v1/retail_listings/${analysisId}`);
    },
    create(data) {
      return http().post(`/v1/retail_listings`, data);
    },
    update(data) {
      return http().put(`/v1/retail_listings/${data.id}`, data);
    },
    delete(analysisId) {
      return http().delete(`/v1/retail_listings/${analysisId}`);
    },
  },
};
